import Axios from "../config/Axios";

export const ApiBulkCreateUsuariosSaefman = async (data) => {
  try {
    const result = await Axios.post("/POSTbulkCreateUsuariosSaefman", data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      mensaje: e?.response?.data?.mensaje || e?.message || "Error de conexión",
      data: { created: 0, errors: [] },
    };
  }
};
